module.exports = __webpack_public_path__ + "img/Amazon_Logo_RGB_SQUID.8826a844.png";